<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('settings.transaltion.editTranslation') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="customer-translation-edit-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('ui.language') }}:
            </label>

            <d-form-select
              v-model="language"
              :options="languageOptions" />
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('customer.termsOfSale') }}:
            </label>

            <validation-provider
              rules="required"
              name="terms_of_sale"
              v-slot="{ errors }">
              <d-textarea
                :state="errors.length ? 'invalid' : null"
                :value.prop="terms_of_sale"
                v-model="terms_of_sale"
                :rows="5" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('customer.termsOfSaleIndent') }}:
            </label>

            <validation-provider
              rules="required"
              name="terms_of_sale_indent"
              v-slot="{ errors }">
              <d-textarea
                :state="errors.length ? 'invalid' : null"
                :value.prop="terms_of_sale_indent"
                v-model="terms_of_sale_indent"
                :rows="5" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('ui.saveChanges') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-translation-edit-popup',
  props: {
    customerID: {
      default: 0,
      type: Number
    },
    translationData: {
      default: () => ({}),
      type: Object
    },
    languages: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    languageOptions () {
      return this.languages.filter(language => language.id > 1).map(language => ({
        value: language.id,
        text: language.name
      }));
    }
  },
  data () {
    return {
      language: this.translationData.language_id,
      translationID: this.translationData.id,
      terms_of_sale: this.translationData.terms_of_sale,
      terms_of_sale_indent: this.translationData.terms_of_sale_indent
    };
  },
  methods: {
    handleClose (translationID) {
      this.$bus.$emit('customer-translation-edit-popup-close', translationID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-translation-edit-form'], this.saveTranslation);
    },
    saveTranslation () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/customers/translations/update/' + this.translationID,
        formData: {
          customer_id: this.customerID,
          language_id: this.language,
          terms_of_sale: this.terms_of_sale,
          terms_of_sale_indent: this.terms_of_sale_indent
        },
        successTitle: this.$t('settings.transaltion.translationEditSuccessTitle'),
        successText: this.$t('settings.transaltion.translationEditSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.transaltion.translationEditErrorText'),
        successAction: res => {
          this.$bus.$emit('customer-reload-translations');
          this.handleClose(res.id);
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
